const ROUTE_VIEWS = Object.freeze({
  DAY_USE_INITIAL_VIEW: "show-activities",
  DAY_USE_REG_FORM_VIEW: "registration-view-form",
  DAY_USE_REG_VIEW_ADD_CARD_VIEW: "registration-view-add-card",
  DAY_USE_REG_VIEW_PRECONFIRM_VIEW: "registration-view-preconfirm-view",
  DAY_USE_CONFIRMATION_VIEW: "day-use-confirmation-screen",
  DAY_USE_BASKET_DETAILS_VIEW: "show-basket-details",
  DAY_USE_HOTELS_VIEW: "show-hotels-details",
  DAY_USE_SINGLE_HOTEL_VIEW: "show-hotel-details",
  DAY_USE_MY_BOOKINGS_VIEW: "day-use-booking-details",
});

const CLASS_CONSTANTS = Object.freeze({
  CUSTOM_MADE_CLASS_PREFIX: "bl-",
  TEXT_CSS_CLASS_IDENTIFIER: "bl-text-",
  IONIC_CSS_CLASS_IDENTIFIER: "ion-",
  CLASS_NOT_FOUND_TEXT: "undefined",
});

const IMAGE_FORMATS = Object.freeze({
  XXLARGE: "xxlarge", //2000px
  XLARGE: "xlarge", //1600px
  LARGE: "large", //1000px
  MEDIUM: "medium", //750px
  SMALL: "small", //500px
});

const MOBILE_PLATFORM = "mobile";
const DESKTOP_PLATFORM = "desktop";
const POUND_SYMBOL = "£";

export {
  ROUTE_VIEWS,
  MOBILE_PLATFORM,
  DESKTOP_PLATFORM,
  IMAGE_FORMATS,
  POUND_SYMBOL,
  CLASS_CONSTANTS
};
